import React from 'react';
import styles from './toolbar.module.css';

interface ToolbarRadioProps {
  label: string;
  active: boolean;
  onClick: () => void;
  /**
   * Shared group name so a set of radios is mutually exclusive and
   * keyboard-navigable as one control. Give every option in a group the same
   * name.
   */
  name?: string;
}

/**
 * Single-select filter option rendered as a native radio + label. Render a set
 * of these sharing one `name` for a "pick one" switch (e.g. a status view).
 * The toggle equivalent for booleans is `ToolbarCheckbox`.
 */
export const ToolbarRadio: React.FC<ToolbarRadioProps> = ({
  label,
  active,
  onClick,
  name,
}) => (
  <label className={`${styles.checkbox}${active ? ` ${styles.checkboxActive}` : ''}`}>
    <input type="radio" name={name} checked={active} onChange={onClick} />
    {label}
  </label>
);
